import { SVGProps } from 'react';
export const ScanBilby = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		id="Layer_2"
		data-name="Layer 2"
		viewBox="0 0 814.97 862.54"
		{...props}
	>
		<defs>
			<style>
				{
					'.cls-3{fill:#a8b5c3}.cls-6{fill:#1a385d}.cls-10{fill:#1a385b}.cls-16{fill:#6eb3d8}.cls-17{fill:#2c445e}.cls-20{fill:#1e3a5c}.cls-32{fill:#1a375b}.cls-37{fill:#fefefe}.cls-51{fill:#193659}'
				}
			</style>
		</defs>
		<g id="Layer_1-2" data-name="Layer 1">
			<path
				d="M348.24 276.16c.39-.72.42-1.38.03-1.84-.09.69-.13 1.35-.03 1.84Z"
				className="cls-10"
			/>
			<path
				d="M810.08 534.44c-8.2-18.4-23.25-24.53-21.89-47.18.55-9.14 7.86-25.21-8.27-15.27-14.1 8.69-31.84 27.1-38.87 42.13-13.89 29.71-7.52 70.5 28.13 78.71 3.18 61.08-61.24 99.74-113 65.29l7.03-81.62c34.59-25.83 27.94-70.33 13.48-105.68-5.95-14.55-9-13.67-8.51-31.57.6-21.85 1.8-44 1.08-66-1.83-56.12-16.35-95.71 14.15-147.76 36.42-62.16 72.35-100.62 58.33-179.72-1.22-6.88-7.74-36.92-14.24-38.81-5.24-1.52-18.3 10.53-22.29 14.31-58.11 55.09-73.84 122.79-79.98 200.02-.19 2.41.89 13.46-1.51 13.47-8.95-6.45-28.48-20.12-37-8l-4.98-5c-2.14-54.39 4.02-111.74-19.66-162.34-6.71-14.33-24.77-45.73-36.34-55.66-9.94-8.53-12.86-1.17-17.01 8.04-13.28 29.51-17.68 69.46-13.35 101.32 4.72 34.68 21.25 66.65 32.74 99.27.66 2.74-4.47.42-6.36.35-5.59-.2-18.97-1.41-21.1 4.98-2.4 7.19 2.49 10.68 7.08 15.04l9.47 6.01c-41.96 24.46-38.95 79.86-72.98 110.53-9.26 8.35-21.67 16.05-33.92 18.41-9.41-19.7-18.3-39.85-28.21-59.31-4.72-9.26-10.34-21.13-15.88-29.62-3.25-4.7-6.92-7.04-11-7l-6.8 1.6c-.05.31-.1.62-.15.92.39.46.36 1.13-.03 1.84.17.79.7 1.18 1.98.64l1.51 1.82c4.79-.64 7.89 2.53 10.01 6.55 14.51 26.04 27.43 52.59 38.75 79.65l-10.4-19.43c-2.14-1.58-3.71-1.27-2.86 1.42.71 5.85 2.97 11.64 6.79 17.36 5.68 7.01-5.7 4.78-10.07 3.69-10.58-19.92-49.26-30.45-58.36-4.22-5.11 14.72 13.3 31.73 26.09 35.52 16.66 4.94 33.91 9.89 51.01 14.35 5.08 1.32 10.32 1.83 15.54 2.3l1.15 2.34c9.22-1.73 11.84 11.52 5.77 14.59-20.34 10.29-40.52 20.44-61.25 29.97-3.94 2.73-5.07 3.29-3.4 1.69l-9.01-16.41.74-4.17 1.23-2.14a227.732 227.732 0 0 0-18.51-36.78c-.34-8.64-3.48-14-9.44-16.09l-27.01-59.92c-1.69-5.03-4.45-8.73-8.27-11.08-.02-1.27-.68-2.6-2-4 4-6.64-5.54-8.98-7.97-.57-1.44 4.98-.82-.86-.35-3.77a313.885 313.885 0 0 1 40.8-18.31l.53-2.34c2.15-1.3 4.49-2.3 7-3 4.83 1.88 14.35-2.71 17-7 1.46-.72 2.53-1.71 3.02-2.64-.1-.5-.07-1.15.03-1.84-.44-.52-1.41-.77-3.05-.52-3.61-.13-7.26.73-10.95 2.6-17.65 8.33-35.33 15.47-53.05 21.4-17.03 9.04-7.75 22.54-1.86 35.36 8.7 18.93 19.03 37.26 27.85 56.15-10.98 4.75-13.44 25.04.01 27.5-2.05 6.16-4.57 10.06-.85 16.34 3.53 5.96 11.21 6.09 11.75 6.74.87 1.04-1.19 10 5.14 14.36 5.04 3.48 13.46 2.47 15.76 3.75.45.25 2.85 5.44 3.79 6.7 4.81 6.45 9.5 11.48 18.33 9.15 10.33 22.43 31.59 45.29 55.55 52.98 1.95.63 9.73 2.97 11.03 2.97h14.5c-14.04 35.66-20.95 73.83-13.32 111.82.63 3.13 3.2 8.27 3.19 10.68 0 5.01-7.88 26.66-9.41 34.46-5.34 27.25-6.75 56.96.03 84.04 1.87 7.49 5.35 13.7 7.49 20.52.95 3.03-2.32.48-2.49.48h-27c-16.01 0-38.4 16.91-45.5 31-2.71-.98-4.98 4.6-5.39 6.86-1.05 5.75.92 6.67 5.78 8.83 3.62 1.61 15.31 3.55 17.62.3 33.34.57 66.68.57 100 0 1.27 2.86 8.42 2.58 11.53 2.2 7.75-.95 10.89-2.23 9.45-10.81-.43-2.57-2.22-9.02-4.98-8.39.01-1.34.38-2.53 1.11-3.59-9.61-35.25-18.7-107.03 32.32-113.09 56.71-6.74 78.35 49.83 90.46 94.38-3.74 1.13-7.39 2.62-10.72 4.67-5.71 3.52-14.99 10.76-14.17 17.64-4.66.67-8.88 14.34-8.82 18.9.05 4.07.38 5.2 3.8 7.69 11.06 8.08 69.98 3.56 84.8 1.22 14.89-2.35 28.24-5.53 18.61-23.33-.38-.7-1.51-.68-2.38-.47-3.44-8.55-7.82-16.79-11.02-25.48-12.5-33.92-18.27-70.29-17.97-106.52 42.06 18.69 95.47 6.96 121.4-32.09 13.99-21.07 19.17-46.05 17.57-71.2 21.27-11.93 25.51-34.44 15.88-56.06Zm-336.41-66.7c-4.83 6.23-19.21 12.34-26.96 13.04-23.77 2.15-32.36-9.08-46.46-25.48 13.19-10.16 42.45-12.56 34.98-35.49l53.92 11.08c2.09 3.06-12.25 32.71-15.47 36.86Z"
				className="cls-10"
			/>
			<path
				d="M588.22 821.79c-2.2 3.9-4.42 8.64-5.51 12.99-1.94 7.74-3.14 10.86 5.49 13.52 15.14 4.67 83.77 3.03 96.35-5.68 7.11-4.92 2.17-10.61-.33-16.83 2.67-1.33 6.49-.27 9.46.05 8.23.89 48.79 5.72 52.09 11.95 1.46 2.74-.84 4-2.85 5.2-15.77 9.39-87.81 14.45-109.2 15.8-87.42 5.51-179.36 4.16-267.03 1.05-103.06-3.65-206.92 7.31-309.82-8.18-6.68-1.01-38.66-6.08-41.19-10.85-3-5.66 16.19-9.57 20.18-9.88 2.56-.2 8.59.41 10.37.88l2.77-1.26c35.78 15.42 78.48 15.62 117.23 14.94 47.02-.82 99.12-2.33 141.52-23.83l3.47.15 29.54.04c4.2-.11 11.69-3.47 14.46.96-4.44 8.81-7.24 12.32 4.76 14.74 3.81.77 9.25 1.06 13.24 1.26 33.33.57 66.66.57 100 0 4.45-.09 10.29.59 14.44-.06 9.31-1.47 3.11-11.28 1.56-16.94-3.99-7.74 16.69-5.27 17.27-4.28.41.7.39 1.51.23 2.28.08-.79.37-1.98.93-2 19.73-.63 42.51-.91 62.18 0 3.7-.69 5.99-.02 6.89 2 .95-3.12 11.05-1.11 11.5 2Z"
				style={{
					fill: '#c2e2e5',
				}}
			/>
			<path
				d="M46.22 831.79c-21.64-11.03-36.86-29.14-42.5-53-7.67-32.4-1.58-63.27 1.5-95.51 2.68-28.04 2.91-52.89 11.74-80.26 14.11-43.71 50.52-77.09 95.27-87.24.24-2.65.05-1.62-1.5-1.98-27.27-6.24-56.47-22.32-70.31-47.71-7.88-14.46 2.88-14.02 15.32-15.29 36.56-3.74 70.9 4.14 97 30.97 2.22 2.28 8.61 11.82 10.91 11.94 1.29.07 3.2-.97 5.03-.97 1.99 0 10.13.76 10.61.53.93-.43 11.23-12.63 13.92-15 25.55-22.54 57.57-32.02 91.55-29.52 20.42 1.5 24.31 5.37 12.28 22.35-15.65 22.1-41.39 38.5-67.83 44.18 20 6.67 39.51 16.05 56.73 28.28 34.21 24.3 43.05 52.37 50.96 92.04 11.2 56.16 30.85 148.2-25.69 186.19-39.72 26.69-140.68 26.92-188.54 25.04-17.27-.68-38.22-2.7-54.88-7.12-7.5-1.99-14.79-6.12-21.57-7.93Z"
				style={{
					fill: '#18375c',
				}}
			/>
			<path
				d="M304.01 219.09c3.38-.32 9.83-1.54 10.25 3.25.53 6.02-12.52 4.79-17.27 5.72-23.9 4.7-42.89 22.43-51.05 44.95-1.38 3.82-1.78 12.86-6.23 12.86-5.79 0-2.91-7.97-1.8-11.89 7.87-28 37.2-52.18 66.09-54.9ZM313.97 254.55c-1.57 1.55-11.13 1.37-14.97 2.52-6.72 2.02-14.96 8.24-19.19 13.81-2.55 3.35-7.44 15.67-10.1 15.97-6.67.75-2.2-10.27-.52-13.59 5.51-10.9 24.14-24.74 36.49-25.5 4.45-.27 13.9 1.23 8.29 6.79Z"
				className="cls-16"
			/>
			<path
				d="M366.22 278.79c-3.57-2.61-6.18-6.45-11-7l-5.66 1.3c-.19 2.23-1.63 2.47-4.34.7-19.7 5.78-40.04 16.67-59.63 23.87-1.28.47-3.42 2.21-4.37.13 21.07-5.87 46.08-22.29 66.8-26.7 9.33-1.99 13.23.08 18.2 7.7Z"
				style={{
					fill: '#0d1c42',
				}}
			/>
			<path
				d="M726.21 14.79c-1.7-1.47-13.94 9.58-16 11.49-55.66 51.42-71.68 117.07-77.98 190.02-.46 5.29-1.07 38.2-3.02 39.49-5.02 3.3-4.84-8.76-5.19-10.29-1.35-5.92-22.45-18.03-28.16-17.42-5.89.63-.6 10.67-7.93 8.56-2.38-.68-15.52-15.84-19.23-18.83-2.65-2.13-19.38-13.16-19.49-5.57-.07 4.94 10.98 10.56 8.53 15.54-2.25 4.57-7.65-1.24-11.26-2.75-7.8-3.27-30.6-8.81-38.01-5.49-3.12 1.4-2.06 2.41-.24 4.74 3.49 4.49 17.45 9.94 15.85 15.79-6.77 6.62-14.64 11.97-20.88 19.19-22.43 25.97-24.87 61.71-47.46 87.54-9.99 11.42-36.64 29.99-52.01 29.99h-18.5c3.47 8.69-1.1 15.16-7 20.99 9.92 3.27 19.89 6.32 30 9.01l50.86-1.46c28.61-3.06 56.79-9.21 84.53-18.45 36.46-8.3 73.25-8.59 66.15 38.77-5.71 32.85-8.93 67.3-9.54 101.46-.02 1.26.31 2.54.65 3.85s.83 2.58 1.35 3.84c25.05 5.03 34.76-6.22 32.98-30.48-.51-7.06-4.14-16.05-2.94-22.98.21-1.18.58-2.36 1.94-2.54 5.93 11.91 8.21 25.19 7.05 38.53-2.92 33.63-45.6 28.11-65.05 11.98-14.58-12.1-11.39-39.15-29.96-50.04-13.08-7.68-44.82-7.73-39.02 14.53 3.88-1.43 7.44-3.85 11.44-5.04 2.89-.86 14.21-3.95 15.4-.31 2.25 6.86-6.16 4.7-10.92 5.8-12.76 2.95-22.63 11.45-13.43 24.56.93-4.45 17.51-15.1 19.41-9.39 1.55 4.66-6.29 6.06-9.42 8.39-9.98 7.43-10.57 22.55 1.95 27.04 14.21 5.1 1.44-7.85 6.25-11.11 4.98-3.37 5.99 5.76 7.88 8.99 3.89 6.63 9.37 8.71 16.37 10.63 2.3.63 4.83.02 7.04.96 2.47 1.05 12.15 9.45 16.1 11.9 27.3 16.92 61.43 25.34 87.93 2.1 29.86-26.2 19.57-75.64 2.22-106.26-1.08-1.91-3.08-1.74-3.31-3.71-1.2-10 .97-21.13 1.12-30.99.69-43.79-4.71-84.19-6.03-127.05-1.91-62.2 31.52-88.1 57.51-138.47 24.9-48.26 31.4-95.13 11.47-147.02Z"
				className="cls-3"
			/>
			<path
				d="M590.21 382.3c-29.58-8.83-79.73 14.78-112.64 19.35-22.17 3.08-42.39 1.49-63.85 3.15-1.94.15-4.12.48-5.51 2 24.85 6.62 50.5 12.01 75.81 16.69 6.11 1.13 13.52 1.31 19.25 2.75 1.84.46 3.77.82 4 3.06.73 6.94-11.04 1.48-12.06 2.49-3.63 20.56-16.36 37.77-25.52 55.98-20.87 41.47-39.03 78.94-37.48 127.02 3.07 37.98 34.49 61.49 70.7 66.14 59.26 7.62 88.46-41.76 98.68-92.86l-1.38-3.28c-7.65-2.15-17.71-6.87-24.67-10.83-5.75-3.27-14.7-11.53-19.4-13.6-4.37-1.92-9.56-1.4-14.81-4.19-2.64-1.41-7.86-7.01-8.75-7.19-1.35-.26-4.02 1.52-5.96 1.73-11.95 1.33-20.87-7.96-21.44-19.48-.12-2.35 1.39-4.46.86-6.69-.62-2.63-4.77-5.8-5.58-10.5-1.24-7.16 1.92-11.24 1.71-15.68-.14-3.05-2.21-5.53-2.02-10.1 1.04-24.7 41.22-23.54 55.09-10.01 10.49 10.24 12.66 25.2 18.47 37.53 4.52 9.57 18.44 16.99 28.5 19-.27-26.86 2.29-53.69 5.13-80.37 2.74-25.77 16.81-61.99-17.13-72.12Z"
				className="cls-37"
			/>
			<path
				d="M675.22 821.79c.07.56.09 1.11-.08 1.59-1.62 4.66-14.75-9.12-16.72-11.37l.79-2.22c-.24-.36.38-2.07-.98-3.48-6.34-6.6-26.28-6.77-34.88-6.65-15.79-43.3-32.92-101.75-88.64-103.85-72.67-2.73-64.31 83.73-50.49 130.98l-1.78 1.14c-10.9-10.01-22.64-18.39-35.22-25.14 1.51-6.41-6.58-5.74-9.05-8.71-1.29-1.56-3.76-8.6-4.7-11.04-14.69-38.55-8.47-83.58 2.76-122.24 1.24-.03 4.99 10.24 6.98 7.99-4.89-19.02-10.35-33.93-10.99-54 3.02 6.35 3.86 13.45 6.52 19.98 13.39 32.94 56.03 49.65 89.71 43.75 44.36-7.77 64.11-54.12 71.77-93.73 18.52 5.21 38.93 6.24 55.99-4l-7.03 86.46c-2.3 58.37 4.62 100.83 26.04 154.54ZM575.21 214.79c-10.18-8.93-36.44-22.87-31 3l-7.78-2.2c-9.24-27.98-23.83-54.92-30.92-83.59-10.43-42.14-5.3-85.03 12.73-124.21 1.32-.96 4.97 3.46 5.96 4.52 11.39 12.21 25.26 35.5 32.2 50.8 21.76 47.95 16.51 100.34 18.81 151.68Z"
				className="cls-3"
			/>
			<path
				d="M418.22 415.79c-19.97-5.71-40.08-11.11-60.01-16.49-16.48-4.45-42.16-23.52-26.84-41.86 10.94-13.09 33.6-7.05 44.39 3.3 2.29 2.2 4.99 7.7 7.18 8.82 4.22 2.15 11.57.86 16.27 1.22-3.44-8.19-7.82-16.17-12-23.99-.47-1.97-.97-3.93-1.63-5.84-.65-1.9-1.31-3.78-2.24-5.51-8.55-15.92-17.37-31.76-26.98-47.08-15.88 5.77-31.68 11.92-47.23 18.49-1.27.53-2.43 1.33-3.59 2.16-1.17.84-2.26 1.8-3.33 2.79-4.27.95-8.48 2.2-12.63 3.76l.63 2.24c12.82 21.55 22 49.84 33.93 72.32 9.42 3.26 6.46 8.26 8.61 14.64 1.57 4.64 8.9 12.95 10.34 18.66l9.12 20.38c-1.76 1.7-.97 3.16 1.3 3.87 3.76 1.18 51.65-21.94 58.96-26.14 3.61-1.15 5.53-3.06 5.74-5.73Z"
				style={{
					fill: '#f8f8f8',
				}}
			/>
			<path
				d="m802.22 575.79-1.55-1.68c.51-.44 6-17.66 4.23-16.65-9.96 28.07-50.48 26.98-59.61-1.03 1.99 8.99 7.79 15.99 14.08 22.37.64 1.92-.24 2.73-2.16 1.98-19.66-15.17-20.53-40.99-10.86-62.36 7.59-16.77 21.78-29.94 36.36-40.64.18 4.84-1.64 9.62-1.58 14.51.21 17.41 13.81 26.96 21.24 40.82 7.28 13.59 9.3 29.62-.17 42.67Z"
				className="cls-37"
			/>
			<path
				d="M395.11 457.87c-3.68 1.43-27.35 11.52-27.82 13.52 13.11 28.84 43.66 57.45 77.5 51.48l21.42-41.07c-28.55 13.57-55.44 1.7-71.11-23.93ZM787.21 592.79c2.88 16.62-1.2 35.39-7.82 50.68-16.67 38.49-53.65 55.78-94.54 52.2-4.84-.42-26.96-5.28-29.14-8.86-2.34-3.85 1.83-15.07.52-20.01 7.86 3.18 15.34 7.09 23.79 8.7 54.66 10.42 95.05-28.16 96.2-81.71l11-1Z"
				className="cls-3"
			/>
			<path
				d="M447.22 802.79c.76-.69.87-2.01 1.47-1.92 1.24.18 9.09 4.98 10.84 6.11l24.69 19.81c.5 1.72 2.28 2.98 2 4.99-1.3 1.19-25.28-1.63-29 1.01-18.32.95-36.7 1.32-55 0-.89-.8-1.26-.22-.59-2.01 2.28-6.06 9.86-9.02 10.55-15.39-1.99-7.09-14.01 8.43-15.45 11.4-.82 1.68-1.2 6-1.5 6h-19c-.37-4.11 16.18-20 9.47-21.99-3.97-1.18-11.85 12.36-13.24 15.72-2.35 5.67.17 6.3-8.62 5.16-1.46-.19-4.85-.31-4.45-2.21.81-3.93 5.1-10.13 7.82-13.2 17.3-19.52 48.93-22.4 72.56-14.52 4.22 1.41 3.46 4.68 7.46 1.04ZM659.22 809.79c1.6 2.36 9.66 9.8 12.08 11.47 1.33.92 2.38 1.76 3.92.53 1.21 3.03 5.72 11.54 5.84 13.7.09 1.62-.94 1.93-2.12 2.53-3.4 1.73-13.12 3.01-17.37 3.63-11.73 1.71-23.82 1.45-35.35 3.14-1.83-2.25 15.04-21.13 6.49-21.04-4.45.05-12.43 16.51-12.5 21.04h-18c-.73-7.85 10.31-16.97 11.6-21.95.57-2.19-3.42-3.95-5.61-2.57-.84.53-6.39 8.37-7.18 9.84-2.16 4.03-3.95 9.1-3.82 13.69-12.14-.44-9.77-4.81-6.18-13.69 8.92-22.02 30.55-27.44 52.38-23.02 4.76.96 8.18 3.33 11.79 4.28 2.02.54 3.2.7 4.01-1.58Z"
				className="cls-37"
			/>
			<path
				d="M387.22 346.79c-10.19-19.09-21.11-37.9-31.48-56.91-17.6 7.85-35.68 14.65-53.52 21.91l-3.83.57c-5.65 3.55-9.04 4.03-10.17 1.43-1.04-8.69-8.34-1.69-5.54 4.05 10.38 20.95 22.01 42.31 31.25 63.74 5.27 12.22-.8 7.62-4.89-.11-8.32-15.72-17.3-34.25-24.72-50.28-2.41-5.2-4.72-11.53-7.08-16.89.67-1.34.11-4.67.57-5.55 1.82-3.45 37.23-17.64 43.41-19.96 2.07-1.3 4.4-2.3 7-3 6-1.85 11.41-5.05 17-7 2.44-3.22 4.1-3.88 5-2 9.18-1.53 11.68 4.7 15.38 11.12 6.01 10.41 12.15 23.54 17.5 34.5 4.59 9.41 17.74 33.88 19.64 42.36.31 1.37 1.03 5.68-1.52 4.53-1.53-.69-9.91-17.51-11.47-20.54-.25-.49-1.77-4.18-2.53-1.97ZM429.46 421.05c-1.76-4.13-7.54-4.2-11.24-5.25-3.8 2.73-8.4 4.85-12.64 6.86-14.08 6.68-29.46 14.32-43.68 20.32-1.74.73-5.82 2.73-7.24 2.87-1.91.19-1.6-1.63-2.43-2.04-1.8-.89-3.13 2.38-2.84 4.28.16 1.06 9.39 18.34 10.44 18.59 22.47-9.87 44.79-20.64 66.45-32.32 3.7-3.66 5.37-8.2 3.2-13.29Z"
				className="cls-17"
			/>
			<path
				d="M346.99 356.04c11.07-1.36 26.21 7.54 30.73 17.75 12.12 27.37-26.59 23.64-39.47 7.47-8.69-10.9-5.97-23.41 8.74-25.22Z"
				style={{
					fill: '#feae86',
				}}
			/>
			<path
				d="M757.22 580.79c2-.42-1.04-2.54-1.5-3-10.9-10.87-14.7-22.41-13.49-38l5.8 18.69c11.35 25.1 49.36 23.01 55.75-4.63.25-1.1.07-10.99 2.44-8.06l.92 15.42-4.92 14.58c-10.75 14.81-31.1 15.72-45 5Z"
				style={{
					fill: '#e8f1f6',
				}}
			/>
			<path
				d="M323.88 408.45c-4.63 4.69-17.69 5.44-19.45-2.37-4.4-19.55 33.22-11.6 19.45 2.37ZM332.98 418.03c6.06 6.05-9.61 20.97-20.13 13.64-12.16-8.48 13.98-19.78 20.13-13.64ZM335.01 435c8.47-.77 12.14 7.37 6.27 13.35-11.48 11.71-29.48-11.25-6.27-13.35Z"
				className="cls-3"
			/>
			<path
				d="M473.22 838.79c-31.99.63-68.29 1.63-100 0h100Z"
				style={{
					fill: '#010c33',
				}}
			/>
			<path
				d="M457.22 832.79c8.81.02 17.71-.26 26.52 0 .86.03 3.6-.41 1.98 1.01-26.18-1.37-54.12 1.8-80.08.05-1.71-.12-2.01.2-3.42-1.06 18.32.03 36.68-.04 55 0Z"
				style={{
					fill: '#00092e',
				}}
			/>
			<path
				d="M355.22 271.79c-1.28 2.03-3.84 2.03-6 2.01l1 2.99c-.27.04-3.83 1.59-5 2 1.78-2.43 3.37-3.49 0-5 3.67-1.08 5.5-2.51 10-2ZM302.22 311.79c-3.92 1.6-9.42 2.81-12 6-.23-.39-1.96-.95-2.58-2.04-.74-1.32.59-1.85.58-1.96 4.1 3.42 9.9-4.84 14-2Z"
				className="cls-20"
			/>
			<path
				d="M350.22 461.79c.84 1.71 1.1 2.53-1 2-2.02-2.96-5.07-6.23-4.99-10 3.38 1.52 4.34 5.11 5.99 8Z"
				className="cls-17"
			/>
			<path
				d="M350.22 461.79c.78 1.37 3.6 3.18 3 5.99-3.18.53-3.12-2.71-4-3.99l1-2ZM328.22 285.79c-1.79 2.24-4.65 2.11-7 3 1.32-3.45 4.85-2.34 7-3Z"
				className="cls-20"
			/>
			<path
				d="M343.22 735.79c-5.1 74.4-73.91 100.75-138.68 102.3l-7.32 1.7C153.11 842.07 71 845.73 35.3 817.21c-39.6-31.65-28.21-85.15-24.09-128.92 3.71-39.4 3.56-77.72 25.59-112.41 23.8-37.48 73.04-64.04 117.85-57.02 3.35.52 7.44 3.77 11.02 4.98 10.95 3.7 18.49 2.15 24.97-7.71 26.2.48 49.93 8.75 72.59 21.15 36.67 20.07 53.8 41.36 63.67 82.33 8.19 34.04 17.4 81.6 16.31 116.19Z"
				style={{
					fill: '#fb8e3c',
				}}
			/>
			<path
				d="M182.87 503.14c6.64 6.92-.29 16.54-9.16 16.73-7.14.15-11.28-4.18-17.27-5.81-9.06-2.46-22.5-1.78-32.57-3.43-32.65-5.35-64.52-21.37-79.66-51.84 25.48-3.6 53.37-3.91 77.03 7.47 17.42 8.37 29.7 22.57 42.52 36.5 2.03.45 2.21-2.69 3.45-3.46 3.51-2.18 12.87.94 15.65 3.84Z"
				style={{
					fill: '#fc8e3c',
				}}
			/>
			<path
				d="M191.24 505.87c16.34-2.47 33.97-5.73 46.97-16.58l-41.62 9.37c-3.85.44-7.69.32-11.37-.88-.44-1.72.71-2 1.49-3 17.07-22.01 48.27-38.06 76.02-39.98 4.45-.31 33.75-.03 34.49 3.51-19.19 34.16-56.93 55.41-96.54 52.51-4.09-.3-9.71-.26-9.44-4.96Z"
				style={{
					fill: '#fb8e3b',
				}}
			/>
			<path
				d="M197.22 839.79c5.23-4.49 14.82-3.22 21.38-4.12 52.2-7.23 97.62-19.53 117.37-73.63 3.24-8.87 4.25-17.5 7.25-26.25-2.92 92.81-68.46 100-146 104Z"
				style={{
					fill: '#e77420',
				}}
			/>
			<path
				d="M645.22 240.78c4.4-28.23 3.9-56.9 9.49-85 9.16-46.06 33.6-86.74 65.01-120.97 1.71-.03 4.24 19.89 4.49 22.49 4.86 49.22-12.5 88.69-37.58 129.41-9.08 14.73-26.02 41.48-38.38 52.62-.99.89-1.4 1.85-3.03 1.46Z"
				style={{
					fill: '#feae85',
				}}
			/>
			<path
				d="M567.98 312c24.71-3.6 34.56 40.65 10.14 53.19-33.45 17.17-42.99-48.41-10.14-53.19ZM497.96 304.02c14.54-2.33 23.35 13.81 23.35 26.27 0 15.11-14.81 34.13-30.8 24.71-18.18-10.71-13.38-47.64 7.45-50.98Z"
				className="cls-32"
			/>
			<path
				d="M566.22 285.79c1.07-5.3 10.16-5.35 14.49-4.98 6.87.59 24.82 8.71 22.42 17.37-1.15 4.15-7.85-4-9.58-5.21-8.9-6.22-16.9-6.1-27.32-7.18Z"
				className="cls-51"
			/>
			<path
				d="M520.21 281.79c-9.37-2.78-17.07-3.69-26.42-.08-3.89-2.61.43-6.15 3.42-7.41 7.91-3.35 20.49-2.14 22.99 7.49Z"
				style={{
					fill: '#193559',
				}}
			/>
			<path
				d="M576.91 389.98c11.45-3.57 7.2 20.52 5.61 26.61-7.29 27.92-38.34 25.56-57.21 10.62-1.48-1.17-7.56-6.86-7.92-8.12-1.83-6.43 7.25-3.84 11.33-4.31 12.86-1.5 27.47-3.85 37.53-12.47 2.73-2.35 9.47-11.95 10.68-12.33Z"
				style={{
					fill: '#1b385b',
				}}
			/>
			<path
				d="M232.01 675.09c14.63-.41 17.28 2.35 18.25 17.16 1.31 19.9 1.3 40.13 1.92 60.08.32 10.23 2.49 21.7 1.09 32-.71 5.22-5.57 8.88-10.52 9.48-17.48 2.1-39.07 1.22-57.06 1.94-10.15.41-20.77 1.83-30.92 2.08s-18.24-.36-19.55-12.54c-1.99-18.59-1.21-40.1-1.96-59.04-.42-10.58-3.36-26.98-1.95-36.87 2.01-14.14 21.27-10.04 31.45-10.55 22.99-1.14 46.14-3.09 69.25-3.74Z"
				className="cls-37"
			/>
			<path
				d="M140.09 575.92c1.16 1.85-1.78 6.66-1.89 8.87-17.47-10.31-39.76-4.42-41.97 17.51s12.27 29.11 31.53 28.53c1.6-.05 5.9-1.4 6.42-1.03.33.24 1.64 6.67 2.04 7.97-28.58 8.15-57.25-8.73-49.55-41.04 4.69-19.71 21.96-27.05 40.94-24.84 1.81.21 11.96 3.19 12.48 4.02Z"
				className="cls-6"
			/>
			<path
				d="M214.13 569.88c1.66 1.96-4.19 20.04-3.9 23.91 15.88-7.23 32.35 4.92 23.81 22.32-6.8 13.84-30.43 16.34-41.85 7.1 5.8-18.06 11.56-36.33 13.04-55.41 1.42.59 8.6 1.74 8.9 2.08Z"
				style={{
					fill: '#19375d',
				}}
			/>
			<path
				d="M252.22 594.8c-1.18 5.49-9.26 25.35-1.31 27.8 13.57 4.18 13.23-20.21 16.25-22.38 1.94-1.39 5.69.45 7.98.65-2.72 26.84-20.13 63.63-51.91 41.93 2.93.63 6.03-6 6.65-6.09 1.69-.27 7.42 2.5 10.12 2.83 5.83.71 12.88-1.28 15.22-7.26.9-2.3-5.04-1.41-7.05-1.93-11.98-3.07-10.17-13.53-7.87-22.98 1.69-6.93 3.05-16.67 11.93-12.56Z"
				style={{
					fill: '#19385d',
				}}
			/>
			<path
				d="M158.22 587.79c-.77 13.17 1.63 26.13 4 39l-7 1c1.23-9.05-3.4-3.09-8.03-1.53-17.99 6.08-23.65-8.43-21.87-23.86.72-6.2 1.4-10.48 8.43-9.66 6.07.71 1.06 7.53.59 12.68-1.7 18.63 14.55 14.28 15.69 6.68-.93-3.68-1.59-22.58.29-24.19.78-.67 6.21.22 7.9-.11Z"
				style={{
					fill: '#19375c',
				}}
			/>
			<path
				d="M173.09 586.92c1.26.82 2.64 11.68 2.14 13.87 2.85.49 2.92-3.78 4.56-5.93 2.16-2.83 9.94-9.28 13.49-6.65.63.46 1.98 5.34 1.81 6.01-.19.76-7.44 3.97-9.35 5.6-9.98 8.5-8.11 25.48-9.53 26.97-.36.38-6.5-.24-8 .01.34-13.4-1.21-26.9-3.99-40 2.02.41 7.61-.69 8.86.12Z"
				className="cls-6"
			/>
			<path
				d="M568.22 362.78c10.24-8.37-.7-35.77-12.53-25.02-1.87 1.7-1.58 4.29-3.46 5.02-1.34-8.65 4.49-22.84 13.72-24.76 25.6-5.33 28.27 44.37 2.27 44.76Z"
				className="cls-37"
			/>
			<path
				d="M566.99 341.04c2.1 2.27.95 8.69 1.23 11.75-1.9 2.36-4.98-7.02-5.04-8.53-.13-3.35 1.34-5.9 3.81-3.22Z"
				style={{
					fill: '#f5f7f8',
				}}
			/>
			<path
				d="M502.22 351.78c4.44-6.57 2.24-17.52-4.49-21.99-4.15-2.75-9.05-1.88-11.28 2.73-1.01 2.08-.46 5.46-2.22 6.27-1.38-10.09 1.83-27.88 14.49-29.04 19.2-1.75 23.2 37.99 3.5 42.03Z"
				className="cls-37"
			/>
			<path
				d="M499.04 333.01c1.11 1.6 1.16 8.48 1.18 10.78-2.78.48-5.65-7.09-5.59-8.5.12-2.83 3.01-4.3 4.41-2.28Z"
				style={{
					fill: '#f8f9f9',
				}}
			/>
			<path
				d="M573.22 422.8c-.58 4.64-22.14 12.29-21.98 7.49.06-1.83 18.63-9.12 21.98-7.49Z"
				style={{
					fill: '#f89a42',
				}}
			/>
			<path
				d="m215.22 762.79-6 1c3.2-15.02-8.18-8.17-10.01-10-.39-.39-.4-10.63 0-11.01 2.14-2.02 5 1.46 5.8 1.9.71.4 2.36-.04 3.23.57 1.67 1.17-.6 5.06 5.97 3.54l-.58-19.05c7.47-2.8 15.03-.1 22.58-1.95v14.5c0 2.19-4.76-.56-5.06 3-.4 4.82 4.39 2.94 5 3.56.14.14.18 3.77.04 3.91-.35.36-8.53.8-9.99 1.03v-15c0-.35-6.55-1.44-7-1-.33 1.9.44 11.59 0 12.01-1.75 1.68-5.98-4.47-5.05 6.58.11 1.28 1.03 2.29 1.04 2.42 2.74 1.23 2.72 2.77 0 4Z"
				style={{
					fill: '#193558',
				}}
			/>
			<path
				d="m178.22 694.79 1 31.01-31.01 1c1.48-4.69-2.06-27.9-.56-30.07.48-.69 1.27-.88 2.06-.94l28.51-1Z"
				style={{
					fill: '#1a375a',
				}}
			/>
			<path
				d="M195.22 723.79c0 .59-2.06 4.08-1.01 6 4.48-.51 5.8-.28 6.02 4.48-.07 1.27-4.54.03-5.02.51-.79.79 1 17.03-.14 18.85-.34.55-3.91 1.58-4.9.73-1.72-1.25-.34-5.08-1.37-6.65-.98-1.49-3.63-.49-4.85-.98-.89-.36-.71-1.75-1.42-1.92-1.84-.44-10.13.74-10.33-.6v-4.43h9.01c.65-3.13-2.97-1.85-3.83-4.69-2.32-7.73 7.16-4.88 11.84-5.3-.22-1.93.48-4.67-.12-6.39s-2.76-1.19-3.6-1.87c-2.46-1.98.12-9.4 2.72-6.74.24.25-.38 2.5.06 2.89.86.76 6.38-1.73 6.94 5.11.91.18.87.52 0 1Z"
				className="cls-51"
			/>
			<path
				d="M189.22 707.79c.02-.09 1.26-.18 1-.99-1.47-.29-7.64.36-8 0-.5-.5-1.59-12.62 3.51-12.07 3.03.33 1.44 6.38 8.5 4.06-1.86-4.47 1.22-4.19 4.99-4 .18 3.69-.74 7.58 1 10.99-2.57.04-6.14-.13-8 2.01 2.26 6.92-5.57 6.25-3 0Z"
				style={{
					fill: '#193457',
				}}
			/>
			<path
				d="M171.22 736.79c-1.79.3-10.6-.41-11.01 0-.34.35.25 5.64.01 7.01h-5.01l1-6h-8v-6.02c7.07 2.37 24.89-6.69 23.01 5.01Z"
				style={{
					fill: '#173055',
				}}
			/>
			<path
				d="m180.22 748.79 1 31.01-30.01 1-1-31.01 30.01-1z"
				style={{
					fill: '#07153a',
				}}
			/>
			<path
				d="M204.22 709.79c-.24-5.36.7-10.8-1-15.99l31-2.01.88 30.9-29.89 2.11c-.18-1.59.26-3.49 0-5.01-.01-3.4-.34-6.73-1-10Z"
				style={{
					fill: '#0b163c',
				}}
			/>
			<path
				d="M186.22 761.79c6.86-1.63 4.29 5.25 5 6 .55.59 8.81-.9 9.02.57v4.43h-9.01c1.05 5.34 1.47 8.02-5 6.99v-18Z"
				style={{
					fill: '#142e51',
				}}
			/>
			<path
				d="M215.22 758.79c6.31-1.47 4.38 4.29 5.03 4.96.48.49 4.57-.35 4.97.03.53.51.27 13.66-.98 14.57-.91.66-3.61-.3-3.88-.73-.9-1.42.45-9.28-.14-9.84-.38-.35-4.31.78-5.58-.97-.9-1.24.6-2.91.58-4.03-.03-1.33.06-2.67 0-4Z"
				style={{
					fill: '#132c4f',
				}}
			/>
			<path
				d="M195.22 722.79c-.62-3.11-2.63-16.33 4.07-11.57 1.98 1.41.46 10.82.93 13.58l-5-1c0-.33.03-.67 0-1Z"
				style={{
					fill: '#112a4e',
				}}
			/>
			<path
				d="M226.21 757.79h10.01v5.01h-10.01z"
				style={{
					fill: '#0d1e43',
				}}
			/>
			<path
				d="M211.22 771.8c-2.33 3.82-.26 8.31-6 6.99-1.19-5.39 1.56-5.52 6-6.99Z"
				style={{
					fill: '#111f3d',
				}}
			/>
			<path
				d="M200.22 762.79h-5.01v-5c4.16-.52 5.53.78 5 5Z"
				style={{
					fill: '#0c1c41',
				}}
			/>
			<path
				d="M189.22 707.79c-.54 3.08-.53 4.75 3 4 .06-1.98-1.19-2.63 0-4 4.93 7.12-7.83 7.4-3 0Z"
				style={{
					fill: '#0d1f40',
				}}
			/>
			<path d="M205.22 719.79c-.64-3.78-.82-5.9-1-10 2.13 2.37.57 6.86 1 10Z" className="cls-10" />
			<path
				d="M203.22 618.78c2.39-7.4 3.58-18.59 13.52-19.05 10.79-.5 12.33 10.89 5 17.07-5.3 4.47-12.23 3.19-18.51 1.98Z"
				style={{
					fill: '#fa8f3b',
				}}
			/>
			<path
				d="M173.22 700.79v20l-18.99.99-1.07-19.41c.33-1.91 17.34-1.64 20.06-1.58Z"
				style={{
					fill: '#fafbfb',
				}}
			/>
			<path
				d="M189.22 735.79c-.09 2.39.85 6-2 7 1.37-3.99-2.89-2.66-3.05-3.5-.89-4.69 1.12-3.51 5.05-3.51Z"
				style={{
					fill: '#f6f8f8',
				}}
			/>
			<path
				d="m179.22 749.79.86 27.86c-1.16 1.85-23.67.98-27.87 2.15l-1-28.01 28.01-2ZM233.22 693.79v25.5c0 .31 1.38 1.41 1 2.49l-28 1.01c.72-9.43-1.52-18.6-1-28.01l28.01-.99Z"
				className="cls-10"
			/>
			<path
				d="m168.21 704.8.59 11.04c-1.42 1.92-8.11.58-10.59.96.3-1.79-.4-10.63 0-11.01.36-.35 8.19.01 10-.99Z"
				style={{
					fill: '#142c50',
				}}
			/>
			<path
				d="M173.72 754.79c.28-.04 1.13-1.51 1.49-1l1.02 21c-6.72-.11-13.39-.22-20.01.99v-16.5c0-.52-1.58-2.16-1-3.5 1.27.49 2.95-1 3.5-1 4.53 0 10.79.58 15 0Z"
				style={{
					fill: '#fbfbfc',
				}}
			/>
			<path
				d="M229.22 697.79v17.5c0 .31 1.38 1.41 1 2.49l-20 1.01-1-20.01 20.01-.99Z"
				style={{
					fill: '#fbfcfc',
				}}
			/>
			<path
				d="M171.22 758.79c-.34 1.89.5 10.39-.06 10.96-.38.39-10.52 1.48-10.95 1.05.34-1.89-.5-10.39.06-10.96.38-.39 10.52-1.48 10.95-1.05Z"
				style={{
					fill: '#1d3759',
				}}
			/>
			<path
				d="M214.21 702.79h11.01v11.01h-11.01z"
				style={{
					fill: '#163054',
				}}
			/>
		</g>
	</svg>
);
